// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__8GVcZ","loaderWhite":"Loader_loaderWhite__yoYDr","loader-white":"Loader_loader-white__23KVC"};